import { OrderLayoutTableFilter } from '../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/useOrderLayoutTableLogic/types'
import { TwinDictionary } from '../../globals/dictionary'

type ExtractWhereFormCompleteDataFiltersTy = (filters?: OrderLayoutTableFilter, defaultSpecificPriceRuleId?: number) => TwinDictionary

export const extractWhereFormCompleteDataFilters: ExtractWhereFormCompleteDataFiltersTy = ((filters, defaultSpecificPriceRuleId) => {
    if (filters && filters.singleFieldsSearch?.['Product.SpecificPriceRuleId']) {
        return { 'Product.SpecificPriceRuleId': filters.singleFieldsSearch?.['Product.SpecificPriceRuleId']?.[0] }
    }
    return { 'Product.SpecificPriceRuleId': defaultSpecificPriceRuleId || 1 }
})